import axios from '@/utils/request'
// 获取菜单列表
export const getAgentList = (params)=>{
 return axios.request({
    url: 'agent',
    method: 'get',
    params
  })
};